import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeCooperationQuestionComponent = (function () {
    function CasePracticeCooperationQuestionComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.assetsRoute = "../../assets";
    }
    CasePracticeCooperationQuestionComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.optionArray = [
            {
                option: '【研发】',
                selected: false
            },
            {
                option: '【总装车间】',
                selected: false
            }, {
                option: '【供应链】',
                selected: false
            }, {
                option: '【售后质量】',
                selected: false
            },
        ];
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/authQuestion/' + this.exerciseId
        }).subscribe(function (result) {
            _this.data = result;
            _this.questions = _this.data.questions;
            _this.questionInit();
        });
        /*this.apiService.ajax({
  
            'type':'get',
            'url':'/api/exercises/'+this.exerciseId
  
        }).subscribe(result=>{
  
        });*/
        /*this.data = this.getMockData();
        this.questions = this.data.questions;
        this.questionInit();*/
    };
    CasePracticeCooperationQuestionComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
    };
    CasePracticeCooperationQuestionComponent.prototype.questionInit = function () {
        if (this.questions.length == this.data.completed.length) {
            this.currentQuestionIndex = this.data.completed.length - 1;
            this.currentQuestion = this.questions[this.currentQuestionIndex];
            this.questionBtnMode = 3;
            this.iconShowMode = this.data.completed[this.data.completed.length - 1].isTrue;
            this.answerShow = this.currentQuestion.answer.split('|').join(' ');
        }
        else {
            this.currentQuestionIndex = this.data.completed.length;
            this.currentQuestion = this.questions[this.currentQuestionIndex];
            this.questionBtnMode = 1;
            this.seletedOptionArray = [];
            this.iconShowMode = 0;
            this.answerShow = this.currentQuestion.answer.split('|').join(' ');
        }
    };
    CasePracticeCooperationQuestionComponent.prototype.optionClick = function (i) {
        if (this.questionBtnMode == 3) {
            return;
        }
        var temp = [];
        this.optionArray[i].selected = !this.optionArray[i].selected;
        this.optionArray.forEach(function (item, index) {
            if (item.selected) {
                temp.push(item.option);
            }
        });
        this.seletedOptionArray = temp;
        if (this.seletedOptionArray.length == 0) {
            this.questionBtnMode = 1;
        }
        else {
            this.questionBtnMode = 2;
        }
        // console.log(this.seletedOptionArray.join('|'));
    };
    CasePracticeCooperationQuestionComponent.prototype.questionBtnClick = function () {
        var _this = this;
        if (this.questionBtnMode == 1) {
            return;
        }
        else if (this.questionBtnMode == 2) {
            this.apiService.ajax({
                'type': 'post',
                'url': '/api/authQuestion/' + this.exerciseId,
                'data': {
                    'authquestion_id': this.questions[this.currentQuestionIndex].id,
                    'isTrue': this.currentQuestion.answer == this.seletedOptionArray.join('|') ? 1 : 2,
                    'answer': this.seletedOptionArray.join('|')
                }
            }).subscribe(function (result) {
                _this.questionBtnMode = 3;
                // console.log(this.currentQuestion.answer);
                if (_this.currentQuestion.answer == _this.seletedOptionArray.join('|')) {
                    _this.iconShowMode = 1;
                }
                else {
                    _this.iconShowMode = 2;
                }
            });
        }
        else if (this.questionBtnMode == 3) {
            if (this.currentQuestionIndex == this.questions.length - 1) {
                this.apiService.ajax({
                    'type': 'post',
                    'url': '/api/pnoStorePoint/' + this.exerciseId,
                    'data': {
                        'pno_store_point_id': 15
                    }
                }).subscribe(function (result) {
                    if (_this.type) {
                        localStorage.setItem('sh', _this.type);
                    }
                    var link = ['case-practice-authorization-main', _this.learningPathId, _this.practiceId, _this.exerciseId];
                    _this.router.navigate(link);
                });
            }
            else {
                $("#questionCard").fadeOut(200);
                this.currentQuestionIndex++;
                this.currentQuestion = this.questions[this.currentQuestionIndex];
                $("#questionCard").fadeIn(200);
                this.questionBtnMode = 1;
                this.seletedOptionArray = [];
                this.optionArray.forEach(function (item, index) {
                    item.selected = false;
                });
                this.iconShowMode = 0;
                this.answerShow = this.currentQuestion.answer.split('|').join(' ');
            }
        }
    };
    return CasePracticeCooperationQuestionComponent;
}());
export { CasePracticeCooperationQuestionComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-cooperation-question/case-practice-cooperation-question.component.ts.pre-build-optimizer.js